function peopleFilter(people = []) {
    return {
        people,
        selectedStates: [],
        filteredPeople: [],

        init() {
            const params = new URLSearchParams(window.location.search);
            const statesParam = params.get('state');
            if (statesParam) {
                this.selectedStates = statesParam.split(',');

                this.$nextTick(() => {
                    const resultsEl = document.querySelector('#results');
                    if (resultsEl) resultsEl.scrollIntoView({ behavior: 'smooth' });
                });
            }

            this.filter();

            this.$watch('selectedStates', () => {
                this.filter();
                this.updateQuery();
            });
        },

        filter() {
            if (!this.selectedStates.length) {
                this.filteredPeople = this.people.map(p => String(p.id));
                return;
            }

            this.filteredPeople = this.people
                .filter(p => this.selectedStates.includes(this.kebab(p.state)))
                .map(p => String(p.id));
        },

        updateQuery() {
            const params = new URLSearchParams(window.location.search);

            if (this.selectedStates.length) {
                params.set('state', this.selectedStates.join(','));
            } else {
                params.delete('state');
            }

            const newUrl = window.location.pathname + (params.toString() ? `?${params.toString()}` : '');
            window.history.replaceState({}, '', newUrl);
        },

        kebab(str) {
            return (str || '').toLowerCase().replace(/\s+/g, '-');
        }
    }
}

// Register Alpine component
document.addEventListener('alpine:init', () => {
    Alpine.data('peopleFilter', (people) => peopleFilter(people));
});
